import { QueryClient } from '@mint-lib/query-client';

export const queryClient = new QueryClient();
